
export function BlogHeroSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            SME Security Hub
          </h1>
          <p className="text-xl text-gray-400 mb-8 leading-relaxed">
            Expert insights, latest threats, and practical cybersecurity advice for UK small and medium-sized enterprises. Stay informed, stay protected.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700">
              <div className="flex items-center justify-center">
                <i className="ri-article-line text-blue-400 mr-2"></i>
                <span className="text-white">Weekly Security Updates</span>
              </div>
            </div>
            <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700">
              <div className="flex items-center justify-center">
                <i className="ri-shield-check-line text-blue-400 mr-2"></i>
                <span className="text-white">Expert Analysis</span>
              </div>
            </div>
            <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700">
              <div className="flex items-center justify-center">
                <i className="ri-lightbulb-line text-blue-400 mr-2"></i>
                <span className="text-white">Practical Tips</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
